import { useCountryShippingDefault } from '@bluheadless/ui-logic/src/hooks/useCountryShippingDefault'
import ChangeCountryLanguageTrigger from '../../molecules/change-country-language'
import { cx } from '@emotion/css'
import { useChangeCountryLanguage } from '@bluheadless/ui-logic/src/providers/change-country-language/change-country-language'

const ChangeCountryLanguage = (props) => {
	const [, { openChangeCountryLanguageDropdown }] = useChangeCountryLanguage()

	const { country: defaultShippingCountry, loading } = useCountryShippingDefault()

	return (
		<ChangeCountryLanguageTrigger
			countryCode={defaultShippingCountry?.code}
			onClick={openChangeCountryLanguageDropdown}
			loading={loading}
			{...props}
			className={cx('language-trigger', props.className)}
		/>
	)
}

export default ChangeCountryLanguage
